export default __webpack_public_path__ + "static/media/UeberMich_2.25b475d4.jpg";